import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {DataSchemaService} from "../_services/dataSchema.service";

@Injectable()
export class SchemaPkResolver implements Resolve<any> {
  constructor(private http: HttpClient,
              private dataSchemaService: DataSchemaService) {
  }

  resolve(activatedRouteSnapshot: ActivatedRouteSnapshot) {
    let daeID = activatedRouteSnapshot.params["id"];
    return this.dataSchemaService.getSchemaPkList(daeID);
  }
}
